var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19444 7.19424C6.68187 7.7068 6.68187 8.53783 7.19444 9.05039L12.1453 14.0013L7.19765 18.9489C6.68509 19.4615 6.68509 20.2925 7.19765 20.8051C7.71022 21.3176 8.54125 21.3176 9.05381 20.8051L14.0015 15.8574L18.9501 20.806C19.4626 21.3186 20.2937 21.3186 20.8062 20.806C21.3188 20.2935 21.3188 19.4625 20.8062 18.9499L15.8576 14.0013L20.8095 9.04943C21.322 8.53686 21.322 7.70583 20.8095 7.19327C20.2969 6.68071 19.4659 6.68071 18.9533 7.19327L14.0015 12.1451L9.05059 7.19424C8.53803 6.68167 7.707 6.68167 7.19444 7.19424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white-close.5d80b9d91b5e8894c0ec98f5220dfe56.svg";
export { ForwardRef as ReactComponent };